import { render, staticRenderFns } from "./Badge.vue?vue&type=template&id=455b7cc2&"
import script from "./Badge.vue?vue&type=script&lang=js&"
export * from "./Badge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports